export default "__VITE_ASSET__Do8G64ay__"